export default __webpack_public_path__ + "static/media/azure-function.4f40b897.svg";